@if (resolvedTable(); as resolvedTable) {
<div class="ui-table">
	<!-- Toolbar for mobile -->
	@if (isMobileView()) {
	<div [libFlexRow]="true" class="push-bottom" [libFlexRowGap]="'16px'">
		@if (tableButtons(); as tableButtons) { @if (tableButtons.length) {
		<div libFlexColumn [libFlexSize]="'full'">
			<lib-button-list [buttons]="tableButtons" [mode]="'extendedList'"></lib-button-list>
		</div>
		}}
		<div libFlexColumn [libFlexSize]="'full'">
			@if (resolvedTable.config.search) {
			<lib-search-input [design]="'default'" (search)="handleSearch($event)"></lib-search-input>
			}
		</div>
	</div>
	}

	<!-- Toolbar for desktop -->
	@if (!isMobileView()) {
	<div [libFlexRow]="false" class="push-bottom" [libFlexRowGap]="'24px'">
		@if ((tableButtons().length) || showDeleteButton()) {
		<div libFlexColumn>
			<div libFlexRow [libFlexRowGap]="'16px'">
				@if (tableButtons(); as tableButtons) { @if (tableButtons.length) {
				<div libFlexColumn>
					<lib-button-list [buttons]="tableButtons"></lib-button-list>
				</div>
				}}
			</div>
		</div>
		}

		<div libFlexColumn [libFlexSize]="isTabletView() ? 'fill' : '300px'">
			@if (resolvedTable.config.search) {
			<lib-search-input
				[focusOnInit]="false"
				[design]="'default'"
				(search)="handleSearch($event)"
			></lib-search-input>
			}
		</div>

		@if (showDeleteButton() === true) {
		<div libFlexColumn>
			<lib-button [buttonType]="'delete'" libConfirm [confirmMode]="'delete'" (confirm)="handleDeleteItems()"
				><span>Delete ({{ selectedItems().length }})</span></lib-button
			>
		</div>
		}
	</div>
	}

	<!-- Header for desktop -->
	@if (!isMobileOrTabletView()) {
	<div class="ui-header-row">
		<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'24px'">
			@if (resolvedTable.config.deleteItems) {
			<div libFlexColumn [libFlexSize]="'25px'"></div>
			} @if (resolvedTable.config.avatar) {
			<div libFlexColumn [libFlexSize]="flexSizeOfAvatarColumn()"></div>
			} @if (resolvedTable.config.mainIcon) {
			<div libFlexColumn [libFlexSize]="'20px'"></div>
			}
			<div libFlexColumn [libFlexSize]="'fill'">
				<span>
					<a class="sort-link" (click)="handleSortByTitle()">
						{{ resolvedTable.config.title.title }}
						@if (sort(); as sort) { @if (sort && resolvedTable.config.title.title === sort.title) {
						<span>
							&nbsp;<lib-icon [type]="sort.order === 'asc' ? 'arrowUp' : 'arrowDown'"></lib-icon>
						</span>
						} }
					</a>
				</span>
			</div>
			<ng-container>
				@for (field of resolvedTable.fields; track field.title) {
				<div libFlexColumn [libFlexSize]="'150px'">
					<span>
						@if (field.sortBy) {
						<a class="sort-link" (click)="handleSort(field)">
							{{ field.title }}
							@if (sort(); as sort) { @if (sort && field.title === sort.title) {
							<span>
								&nbsp;<lib-icon [type]="sort.order === 'asc' ? 'arrowUp' : 'arrowDown'"></lib-icon>
							</span>
							} }
						</a>
						} @if (!field.sortBy) {

						<span class="sort-link not-sortable">
							{{ field.title }}
						</span>

						}
					</span>
				</div>
				}
			</ng-container>
			<ng-container>
				@if (resolvedTable.showButtonColumn) {
				<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? undefined : '80px'" class="actions">
					Actions
				</div>
				}
			</ng-container>
		</div>
		<lib-divider class="push-top"></lib-divider>
	</div>
	}

	<!-- Items -->
	@if (pagedFilteredItems(); as pagedFilteredItems) { @if (pagedFilteredItems.length === 0) {
	<lib-message [type]="'noData'" class="push-top">
		{{
			resolvedTable.items.length === 0
				? resolvedTable.config.noItemsText.noItems
				: resolvedTable.config.noItemsText.noFilteredItems
		}}
	</lib-message>
	} @for (item of pagedFilteredItems; track item.id; let first = $first; let last = $last) {
	<div>
		<lib-tooltip-menu #buttonsMenu>
			@for (button of item.buttons; track button.id; let firstButton = $first; let lastButton = $last) {
			<div>
				<lib-tooltip-menu-item
					[isFirst]="firstButton"
					[isLast]="lastButton"
					(itemClick)="handleButtonClick($event, button)"
					[routerLink]="button.routerLink"
					[title]="button.title"
					[typeIcon]="button.icon"
					[enableConfirm]="button.confirm ? true : false"
					[confirmMode]="button.confirm?.mode"
					[confirmText]="button.confirm?.text"
					[itemDesign]="button.confirm?.mode === 'delete' ? 'delete' : 'default'"
				></lib-tooltip-menu-item>
			</div>
			}
		</lib-tooltip-menu>

		<ng-template #itemTemplate>
			<div class="ui-item">
				<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="isMobileOrTabletView() ? '16px' : '24px'">
					@if (!isMobileOrTabletView()) { @if (resolvedTable.config.deleteItems) {
					<div libFlexColumn [libFlexSize]="'25px'">
						<lib-checkbox-form-input
							(valueChange)="handleSelectItem($event, item)"
						></lib-checkbox-form-input>
					</div>
					} } @if (item.avatar) {
					<div libFlexColumn [libFlexSize]="flexSizeOfAvatarColumn()">
						<lib-image
							[alt]="'Table item avatar'"
							[imageSize]="'50px'"
							[image]="item.avatar.image"
							[avatarName]="item.avatar.name"
							[maxHeight]="45"
							[maxWidth]="45"
						></lib-image>
					</div>
					} @if (resolvedTable.config.mainIcon) {
					<div libFlexColumn [libFlexSize]="'20px'">
						@if (item.mainIcon && item.mainIcon.type) {
						<lib-icon [type]="item.mainIcon.type" [color]="item.mainIcon.color"></lib-icon>
						}
					</div>
					}

					<div libFlexColumn [libFlexSize]="'fill'">
						<div>
							<div libText1 libLineClamp [clampLines]="2">{{ item.title }}</div>
						</div>
						@if (item.subtitle) {
						<div libText3 libLineClamp [clampLines]="2">
							{{ item.subtitle }}
						</div>
						} @if (item.subtitle2) {
						<div libText3 libLineClamp [clampLines]="2">
							{{ item.subtitle2 }}
						</div>
						}
					</div>

					@if (!isMobileOrTabletView()) { @for (field of item.fields; track field.title) {
					<div libFlexColumn [libFlexSize]="'150px'">
						@if (field.format === 'text') {
						<div libText4 libLineClamp [clampLines]="2">
							{{ field.value }}
						</div>
						} @if ((field.format === 'relativeTime' || field.format === 'tag') && field.value) {
						<div>
							<lib-tag [tagType]="field.tagType ?? 'basic'">
								{{ field.value }}
							</lib-tag>
						</div>
						} @if (field.format === 'date') {
						<div libText4 libLineClamp [clampLines]="2">
							{{ field.value }}
						</div>
						}
					</div>
					} } @if (resolvedTable.showButtonColumn) {

					<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? undefined : '80px'">
						<lib-button
							[libTooltipMenu]="buttonsMenu"
							[iconOnly]="isMobileOrTabletView()"
							[iconLocation]="'after'"
							[iconOnly]="true"
							[icon]="'more'"
							[buttonType]="'basic'"
						></lib-button>
					</div>
					}
				</div>

				@if (item.mobileSimpleTableItems.length) {
				<div class="push-top-sm">
					<ui-simple-table [items]="item.mobileSimpleTableItems" [titleValueRowGap]="'0px'"></ui-simple-table>
				</div>
				}
			</div>
		</ng-template>

		<lib-link [routerLink]="item.mainRouterLink" (click)="item.mainItemClick?.()" [linkStyle]="'noUnderline'">
			<div>
				<div
					class="pad-top pad-bottom"
					[class.ui-item-as-link]="item.mainItemClick || item.mainRouterLink ? true : false"
					[class.ui-item-not-clickable]="!item.mainItemClick && !item.mainRouterLink"
					[libHover]="'ui-item-as-link-hover'"
				>
					<ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
				</div>
			</div>
		</lib-link>

		@if (!last) {
		<lib-divider [mode]="'dotted'"></lib-divider>
		}
	</div>
	} @if (showLoadMore()) {
	<div class="push-top" libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'fill' : undefined">
			<lib-button [buttonType]="'basic'" (click)="handleLoadMore()">
				Load more ({{ loadMoreCount() }})
			</lib-button>
		</div>
	</div>
	} }
</div>
}
